<div class="flex flex-col items-center justify-center min-h-screen container-padding">
  <div class="w-full max-w-md bg-[var(--white)] border-4 border-[var(--tertiary)] rounded-2xl p-8 text-center shadow">

    <ng-container *ngIf="isLoading">
      <p class="text-[var(--dark-orange)] font-bold uppercase">{{ 'linkConfirmation.confirming' | translate }}</p>
    </ng-container>

    <ng-container *ngIf="!isLoading && isSuccess">
      <div class="text-green-600 text-5xl mb-4">✓</div>
      <h2 class="uppercase text-[28px]/[36px] font-normal text-[var(--dark-orange)] mb-2">
        {{ 'linkConfirmation.success' | translate }}
      </h2>
      <p class="text-gray-600 text-sm">{{ 'linkConfirmation.successDesc' | translate }}</p>
      <a routerLink="/login" class="mt-6 inline-block uppercase font-bold text-[var(--dark-orange)] text-[14px]/[14px]">
        {{ 'linkConfirmation.goToLogin' | translate }}
      </a>
    </ng-container>

    <ng-container *ngIf="!isLoading && errorMessage">
      <div class="text-red-500 text-5xl mb-4">✗</div>
      <h2 class="uppercase text-[28px]/[36px] font-normal text-[var(--dark-orange)] mb-2">
        {{ 'linkConfirmation.error' | translate }}
      </h2>
      <p class="text-gray-600 text-sm">{{ errorMessage }}</p>
      <a routerLink="/login" class="mt-6 inline-block uppercase font-bold text-[var(--dark-orange)] text-[14px]/[14px]">
        {{ 'linkConfirmation.backToLogin' | translate }}
      </a>
    </ng-container>

  </div>
</div>
